import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useProductDetailSlots } from "../../../../../../../../../../slots/slots/context.js";
import { useFramesEcommContext } from "../../../../../../../context/modules/EcommContent/FramesEcommContent/context/FramesEcommContext.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { isRxProductAction } from "../../../../../../../../../../types/types/typeguards.js";
const FramesDeliveryIndicator = () => {
  const { Slots } = useProductDetailSlots();
  const {
    activeVariant: { sku: activeSku, isExcludedFromCheckout }
  } = useProductData();
  const { productAction, selectedOffering } = useFramesEcommContext();
  const { isDynamicLineItemDeliveryEstimationEnabled } = useFeatureToggles();
  const deliveryIndicatorSkus = selectedOffering?.sku && !isDynamicLineItemDeliveryEstimationEnabled ? [activeSku, selectedOffering.sku, ...selectedOffering.bundledProductSkus] : [activeSku];
  const deliveryItems = deliveryIndicatorSkus.map((sku) => ({ sku, quantity: 1 }));
  return Slots.DynamicDeliveryIndicator ? /* @__PURE__ */ React.createElement(
    Slots.DynamicDeliveryIndicator,
    {
      isExcludedFromCheckout,
      deliveryItems,
      hasRxLens: isRxProductAction(productAction)
    }
  ) : null;
};
export {
  FramesDeliveryIndicator
};
//# sourceMappingURL=FramesDeliveryIndicator.js.map
